import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';
import { DoorConfiguration } from '../door-configuration';
import { isNumber } from '@icc/shared/helpers';

export function changesInVersion14(
    oldConfiguration: any,
    dataRequiredToUpdate: {
        langCode: string;
        windowColorRalsMap: Record<number | string, number>;
    }
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

    if (configuration.type === 'door') {
        (configuration as DoorConfiguration).doorHardware = {
            ...oldConfiguration.doorHardware,
            electronicLock: oldConfiguration.doorHardware.electronicLock != null && isNumber(oldConfiguration.doorHardware.electronicLock) ? {
                id: oldConfiguration.doorHardware.electronicLock,
                color: null,
            } : {
                id: null,
                color: null,
            }
        };
    }

    return configuration;
}


